export default "__VITE_PUBLIC_ASSET__34e9c854__"